export default {
  lastPage: 'Previous',
  nextPage: 'Next',

  'app.head.menu.home': 'Dashboard',
  'app.head.menu.dashboard': 'Dashboard',
  'app.head.menu.blocksAndTxs': 'Blocks & Transactions',
  'app.head.menu.directory': 'Conflux Directory',
  'app.head.menu.more': 'More',
  'app.comp.nodeMap.scatter.name': 'scatterName',
  'app.comp.copyButton.copySuccess': 'Copied',
  'app.comp.toast.error.other': 'system error',
  'app.comp.toast.error.contentDefault': 'internal server error',
  'app.comp.toast.error.networkErr': 'network error',
  'app.comp.toast.error.1': 'parameter error',
  'app.comp.toast.error.2': 'database error',
  'app.comp.toast.error.3': 'full-node error',
  'app.comp.searchbox.filter.all': 'All Filters',
  'app.comp.searchbox.filter.epoch': 'Epoch',
  'app.comp.searchbox.filter.block': 'Block',
  'app.comp.searchbox.filter.transaction': 'Transaction',
  'app.comp.searchbox.filter.address': 'Address',
  'app.comp.searchbox.placeholder': 'Epoch / Block hash / Txn hash / Address',

  'app.pages.account.detail.viewAll': 'View All',
  'app.pages.account.detail.viewOutGoing': 'View Outgoing Txns',
  'app.pages.account.detail.viewIncoming': 'View Incoming Txns',
  'app.pages.account.detail.tokentxns': 'Token Txns',
  'app.pages.account.transaction.age': 'TimeStamp',

  // blocks
  'app.pages.blocks.position': 'Position',
  'app.pages.blocks.hash': 'Hash',
  'app.pages.blocks.gasLimit': 'Gas Limit',
  'app.pages.blocks.age': 'Age',
  'app.pages.blocks.txCount': 'Tx Count',
  'app.pages.blocks.packTime': 'Timestamp',

  // blocks & txns
  'app.pages.account.detail.transactions': 'Transactions',
  'app.pages.account.detail.tab.transactions': 'Transactions',
  'app.pages.blockAndTx.blocks': 'Blocks',
  'app.pages.blockAndTx.viewAllBlocks': 'View All Blocks',
  'app.pages.blockAndTx.viewAllTransactions': 'View All Transactions',

  // age
  'app.pages.txns.age': 'Age',
  'app.pages.txns.time': 'Timestamp',
  'app.pages.txns.Status': 'Status',
  'app.pages.txns.Success': 'Success',
  'app.pages.txns.Err': 'Error',
  'app.pages.txns.Skip': 'Skip',
  'app.pages.txns.inputData': 'Input Data',
  'app.pages.txns.original': 'Original',
  'app.pages.txns.utf8': 'UTF-8',
  'app.pages.txns.decodeInputData': 'Decode Input Data',
  'app.pages.txns.inputTips':
    'The binary data that formed the input to the transaction, either the input data if it was a message call or the contract initialisation if it was a contract creation',
  'app.pages.txns.proposedEpoch': 'Proposed Epoch',
  'app.pages.txns.storageLimit': 'Storage Limit',
  'app.pages.txns.chainId': 'Chain ID',
  'app.pages.txns.tokenTransferred': 'Token Transferred',
  'app.pages.txns.transaction': 'Transaction',
  'app.pages.txns.Unexecuted': 'Unexecuted',
  'app.pages.err-reason.1': 'Error encountered during contract execution, or out of gas',
  'app.pages.err-reason.2': 'Wrong nonce, signature verification failed, or insufficient funds',

  'app.pages.block.confirm.title': 'Please Confirm',
  'app.pages.block.confirm.pageWarning': 'page > 10000 is not supported',
  'app.pages.block.confirm.done': 'Done',

  'app.pages.notFoundTx.title': 'Sorry your <strong>Transaction</strong>',
  'app.pages.notFoundTx.tooltip': 'Copy to clipboard',
  'app.pages.notFoundTx.packing': 'is packing, please wait',
  'app.pages.notFoundTx.ask': 'If you think there is something wrong, please ',
  'app.pages.notFoundTx.concatus': 'contact us',

  'app.pages.pageNotFound.title': 'Page Not Found',
  'app.pages.pageNotFound.row2': 'this url you entered is not available',

  'app.pages.searchNotFound.title': 'Search not found',
  'app.pages.searchNotFound.row2': 'Oops! The search string you entered was:',
  'app.pages.searchNotFound.row4': 'Sorry! This is an invalid search string',
  'app.pages.dashboard.tps': 'TPS',
  'app.pages.dashboard.difficulty': 'Difficulty',
  'app.pages.dashboard.blockTime': 'Block Time',
  'app.pages.dashboard.blockTimeUnit': 's',
  'app.pages.dashboard.hashRate': 'Hash Rate',

  // Header Components
  'app.header.lang.en': 'English',
  'app.header.lang.short.en': 'EN',
  'app.header.lang.zh': '中文',
  'app.header.lang.short.zh': '中',

  // Footer Components
  'app.footer.title': 'CONTACT US',
  'app.footer.address': 'Room 1002, Building B, Xueyandasha, No. 30, Shuangqing Road, Beijing, P.R. China.',

  // Navbar Components
  'app.navbar.home': 'Dashboard',
  'app.navbar.dashboard': 'Dashboard',
  'app.navbar.blocksAndTxs': 'Blocks & Transactions',
  'app.navbar.directory': 'Directory',
  'app.navbar.more': 'More',
  'app.navbar.token': 'Token',

  // Directory Page
  'app.directory.exchange.title': 'Exchange',
  'app.directory.exchange.desc': 'Places to buy and sell cryptocurrencies',
  'app.directory.wallet.title': 'Wallet',
  'app.directory.wallet.desc': 'Crypto Asset Management & Protection',
  'app.directory.website.title': 'Official Website',
  'app.directory.website.desc': 'Official Announcement & Development',
  'app.directory.news.title': 'News',
  'app.directory.news.desc': 'Latest Updates',
  'app.directory.topholders.title': 'Top Token Holders',
  'app.directory.topholders.desc': 'Publicity & Transparency for the Community',
  'app.directory.community.title': 'Community',
  'app.directory.fc.title': 'FansCoin',
  'app.directory.fc.desc': 'Community Token',
  'app.directory.contract.title': 'Contract',
  'app.directory.contract.desc': 'Submit Contract Information',
  'app.directory.community.desc': 'Join the Next Generation Decentralized Application Community',
  'app.directory.ConfluxPortal.title': 'ConfluxPortal',
  'app.directory.ConfluxPortal.desc': 'Conflux DApp Portal & Crypto Asset Management',

  'network.mainnet': 'Conflux Oceanus',
  'network.testnet': 'Conflux Testnet',
  'network-short.mainnet': 'Oceanus',
  'network-short.testnet': 'Testnet',

  'pagination.total': 'A total of <%=total%> records found',
  'pagination.totalLimit': 'Showing the last <%=total%> records',

  'num.Tokens': 'Tokens',
  'contract.at-txn1': 'at txn',
  'contract.at-txn2': ' ',
  'app.pages.account.notfound': 'Not Available',
  'app.pages.account.notfound.tokenTracker': 'Not Available or Verified',

  // Contract
  'app.pages.contract.edit': 'Edit Contract',
  'app.pages.contract.create': 'Create Contract',
  'app.pages.contract.address': 'Contract Address',
  'app.pages.contract.uploadIcon': 'Upload Contract Icon',
  'app.pages.contract.removePhoto': 'Remove photo',
  'app.pages.contract.contractType': 'Contract Type',
  'app.pages.contract.tokenName': 'Token Name',
  'app.pages.contract.tokenSymbol': 'Token Symbol',
  'app.pages.contract.decimals': 'Decimals of Precision',
  'app.pages.contract.uploadTokenIcon': 'Upload Token Icon',
  'app.pages.contract.sourceCode': 'Contract Source Code',
  'app.pages.contract.abi': 'Contract ABI',
  'app.pages.contract.typeinAdminPassword': 'Please enter your admin password',
  'app.pages.contract.nameTag': 'Contract Name Tag',
  'app.pages.contract.generalContract': 'General Contract',
  'app.pages.contract.erc20': 'ERC20',
  'app.pages.contract.erc777': 'ERC777',
  'app.pages.contract.fansCoin': 'FansCoin',
  // Common
  'app.common.submit': 'Submit',
  'app.common.submitTips': 'Please enter all the information',
  'app.common.success': 'Success',
  'app.common.submitSucceed': 'Submit succeed',
  'app.common.sourceCode': 'Source Code',
  'app.common.abi': 'ABI',
  'app.common.officialSite': 'Official Site',
  'app.common.contract': 'Contract',
  'app.pages.index.testnet.notice1':
    '1.ConfluxScan is currently on the testnet network, Conflux-Rust version:v1.0.0-rc-1, all data shown are from the testnet.',
  'app.pages.index.testnet.notice2':
    '2.Conflux Mainnet Phase III - Conflux Tethys will go live on Oct. 29. DApp developers please back-up related data in advance.',
  'app.pages.index.mainnet.notice1': '1. ConfluxScan will go offline starting: 2020.10.28 22:00 (GMT+8)',
  'app.pages.index.mainnet.notice2':
    '2. Conflux Mainnet Phase III - Conflux Tethys will go live on Oct. 29. DApp Developers please back-up related data in advance.',
  'app.pages.index.mainnet.notice3':
    '3. From Oct. 28 18:00 (GMT+8) to Oct. 29 18:00 (GMT+8), the system will be undergoing upgrades and all assets on chain will be frozen temporarily. The assets will be back to normal after the upgrade. Users do not need to take any action.',
  'app.pages.index.mainnet.notice4':
    '4. During the launch of Conflux Tethys, the transfer function of FC will be affected, so please do not transfer any FC during the launch.',

  'security.High': 'Great',
  'security.Medium': 'Good',
  'security.Low': 'Weak',
  'security.Very low': 'Poor',
};
